import { IAnalyticsModelResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export type AnalyticsModelsFilter = Readonly<{
    corporationId?: string;
    locationId?: string;
    nameSearch?: string;
    includeGlobal: boolean;
}>;

export type UseAnalyticsModelDataSourceOptions = BaseDataSourceOptions<
    IAnalyticsModelResponse,
    AnalyticsModelsFilter
>;

const queryFn: DataSourceQuery<IAnalyticsModelResponse, AnalyticsModelsFilter> = ({
    filter: { locationId, corporationId, nameSearch, includeGlobal },
    sort,
    page,
    pageLimit,
}) => {
    const filter = Filter.or(
        includeGlobal ? Filter.eq('IsGlobal', 'true') : undefined,
        Filter.and(
            corporationId ? Filter.eq('CorporationId', corporationId) : undefined,
            locationId ? Filter.eq('LocationId', locationId) : undefined,
        ),
    );
    const orderBy = buildOrderBy(sort);
    return toDataSourceResult(
        sdClient.getAnalyticsModels({ filter, page, pageLimit, orderBy, nameSearch }),
    );
};

export type AnalyticsModelsPagedDataSource = PagedDataSource<
    IAnalyticsModelResponse,
    AnalyticsModelsFilter
>;

export function useAnalyticsModelPagedDataSource(
    options: UseAnalyticsModelDataSourceOptions,
): AnalyticsModelsPagedDataSource {
    return usePagedDataSource({ ...options, query: queryFn });
}

export type AnalyticsModelsInfiniteDataSource = InfiniteDataSource<
    IAnalyticsModelResponse,
    AnalyticsModelsFilter
>;

export function useAnalyticsModelInfiniteDataSource(
    options: UseAnalyticsModelDataSourceOptions,
): AnalyticsModelsInfiniteDataSource {
    return useInfiniteDataSource({ ...options, query: queryFn });
}
